export const calculateRem = (size: number): string => `${size / 16}rem`;
export const calculateRems = (sizes: number[]): string =>
  `${sizes.map((size) => calculateRem(size)).join(" ")} }`;
